import styled from "@emotion/styled";
import { Ui } from "../../../..";
var CloseButton = /*#__PURE__*/ styled(Ui.IconButton, {
    target: "eky19wk0"
})("position:fixed;right:0.75rem;top:0.75rem;width:1.25rem;height:1.25rem;color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";z-index:1;cursor:pointer;");
var ForegroundLayerWrapper = /*#__PURE__*/ styled("div", {
    target: "eky19wk1"
})("max-width:500px;display:flex;flex-direction:column;left:50%;margin:0 auto;position:fixed;bottom:0;transform:translateX(-50%);width:100%;z-index:11;");
export { CloseButton, ForegroundLayerWrapper };
